import React, { FC } from 'react'
import { Controller, ControllerProps } from 'react-hook-form'
import debounce from 'lodash/debounce'
import DateTimeFields, { IDateTimeFieldsProps } from './DateTimeFields'

type IBaseControllerProps = ControllerProps<React.ComponentType<IDateTimeFieldsProps>>

interface IControlledDateTimeFieldsProps
  extends Pick<IBaseControllerProps, 'control' | 'name' | 'defaultValue'> {
  /**
   * Debounce updated values
   * @default 0
   */
  debounceMs?: number
  DateTimeFieldProps: IDateTimeFieldsProps
}

const ControlledDateTimeFields: FC<IControlledDateTimeFieldsProps> = ({
  DateTimeFieldProps,
  control,
  debounceMs = 0,
  defaultValue = '',
  name,
}) => {
  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue}
      render={({ onChange, value }) => {
        const changeHandler = debounce((val: string) => {
          onChange(val)
        }, debounceMs)

        return <DateTimeFields value={value} {...DateTimeFieldProps} onChange={changeHandler} />
      }}
    />
  )
}

export default ControlledDateTimeFields
